module.exports = __webpack_public_path__ + "images/logo-b26666b8128329127b94ad9d1ab63dd3.png";